var getDefaultAdapter = function () {
    if (window.indexedDB) {
        return require('../indexeddb').default;
    }
    if (process && process.env) {
        throw new Error('Node is not supported');
    }
};
export default getDefaultAdapter;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/datastore/lib-esm/storage/adapter/getDefaultAdapter/index.js
// module id = iz8q
// module chunks = 0